import * as StyleHelper from './StyleHelper';
import BorderColorParser from './BorderColorParser';
import ConvertDecToRom from './ConvertDecToRom';
import FetchToBase64 from './FetchToBase64';
import FetchToBlob from './FetchToBlob';
import BlobToBase64 from './BlobToBase64';
import FontSizeConverter from './FontSizeConverter';
import LineHeightCalculator from './LineHeightCalculator';
import PointConverter from './PointConverter';
import RGBParser from './RGBParser';
import SidesParser from './SidesParser';
import SizeConverter from './SizeConverter';
import { createTextFormatter } from './TextFormatter';
import TransformByMatrix2D from './Matrix2DTransformer';
import UrlHelper from './UrlHelper';
import SvgToPng from './SvgToPng';
import workerResolver from './workerResolver';

const CONVERSION_TYPE_ENUM = {
    wetSign: 0,
    wetSignSavedAsPdf: 1,
    eSignSavedAsPdf: 2,
    eSign: 3,
    wetSign2: 4,
    // wetSignSavedAsPdf2: 5,
    // eSignSavedAsPdf2: 6,
    // eSign2: 7,
};

export {
    BorderColorParser,
    ConvertDecToRom,
    FetchToBase64,
    FetchToBlob,
    BlobToBase64,
    FontSizeConverter,
    LineHeightCalculator,
    PointConverter,
    RGBParser,
    SidesParser,
    SizeConverter,
    StyleHelper,
    createTextFormatter,
    TransformByMatrix2D,
    UrlHelper,
    SvgToPng,
    workerResolver,
    CONVERSION_TYPE_ENUM
};
